// Polyfills for Node.js built-in modules
import { Buffer } from 'buffer';
import process from 'process';

// Make Buffer available globally
window.Buffer = Buffer;

// Make process available globally
window.process = process;

// Add other polyfills as needed
if (typeof global === 'undefined') {
  (window as any).global = window;
} 